import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Header, scrollToSection } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { EditorialMarquee } from "@/components/landing/EditorialMarquee";
import { Problem } from "@/components/landing/Problem";
import { Benefits } from "@/components/landing/Benefits";
import { Contents } from "@/components/landing/Contents";
import { Previews } from "@/components/landing/Previews";
import { InsideBook } from "@/components/landing/InsideBook";
import { Author } from "@/components/landing/Author";
import { WhatYouGet } from "@/components/landing/WhatYouGet";
import { Pricing } from "@/components/landing/Pricing";
import { Faq } from "@/components/landing/Faq";
import { FinalCta } from "@/components/landing/FinalCta";
import { Footer } from "@/components/landing/Footer";
import { StickyMobileCta } from "@/components/landing/StickyMobileCta";
import { CookieConsent } from "@/components/landing/CookieConsent";
import { WarmDivider } from "@/components/landing/WarmDivider";

export default function LandingPage() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const t = setTimeout(() => scrollToSection(location.hash.slice(1)), 120);
      return () => clearTimeout(t);
    }
  }, [location.hash]);

  return (
    <main className="bg-navy-deep">
      <Header />
      <Hero />
      <EditorialMarquee />
      <WarmDivider from="#12151a" to="#f8f5f0" />
      <Problem />
      <WarmDivider from="#f8f5f0" to="#1e1b18" />
      <Benefits />
      <WarmDivider from="#1e1b18" to="#f8f5f0" />
      <Contents />
      <WarmDivider from="#f8f5f0" to="#12151a" />
      <Previews />
      <WarmDivider from="#12151a" to="#f8f5f0" />
      <InsideBook />
      <WarmDivider from="#f8f5f0" to="#141c28" />
      <Author />
      <WarmDivider from="#141c28" to="#f8f5f0" />
      <WhatYouGet />
      <WarmDivider from="#f8f5f0" to="#1c2128" />
      <Pricing />
      <WarmDivider from="#1c2128" to="#f8f5f0" />
      <Faq />
      <WarmDivider from="#f8f5f0" to="#12151a" />
      <FinalCta />
      <Footer />
      <StickyMobileCta />
      <CookieConsent />
    </main>
  );
}
